import moment from 'moment'

/** Source registry lookups. The registry itself is served by /api/lucky-draw/sources. */

// The uploaded sheet supplies the companies rather than the AX points list.
export const MANUAL_SOURCE = 'MANUAL'

// The draw's one accent, reserved for winning. Nothing else on the wall may use it.
export const GOLD = '#f7c948'

/** The accent's bloom. */
export const GOLD_GLOW = `0 0 40px ${GOLD}59`

const findSource = (sources = [], key) => sources.find((source) => source.key === key)

export const getSourceLabel = (sources, key) => findSource(sources, key)?.label ?? key

export const getTicketFieldOptions = (sources, key) => findSource(sources, key)?.ticketFields ?? []

/**
 * The ticket fields a group gets without being asked, or empty when there is a real choice. A source
 * offering exactly one type — a manual draw, whose uploaded sheet carries no tiers — leaves nothing
 * to pick, so the field is filled in and its picker hidden.
 */
export const impliedTicketFields = (ticketFieldOptions) =>
  ticketFieldOptions.length === 1 ? [ticketFieldOptions[0].key] : []

/** A ticket count or number as the projector shows it. One formatter, so the two agree. */
export const formatTicket = (ticket) => ticket.toLocaleString('en-MY')

/** Export filename for a draw record, e.g. Lucky_Draw_GMN_Grand_Prize_20260818143210.xlsx */
export const exportFileName = (drawName = 'Draw') => {
  const slug = drawName
    .trim()
    .replace(/[^a-z0-9]+/gi, '_')
    .replace(/^_+|_+$/g, '')

  return `Lucky_Draw_${slug}_${moment().format('YYYYMMDDHHmmss')}.xlsx`
}
